import React, { useEffect, useState } from "react";
import "./UserProfile.css";
import Header from '../HomePage/Header';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import HelpTrigger from '../HomePage/HelpTrigger';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("edit");
  const [userData, setUserData] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    gender: "",
    pincode: "",
    dob: "",
  });


const [coupons, setCoupons] = useState([
        {
          id: 1,
          name: "Festive Delight",
          reason: "Celebrate the season with style!",
          discount: "25%",
          expiry: "2025-12-31"
        },
        {
          id: 2,
          name: "Anniversary Special",
          reason: "Our way of saying thank you!",
          discount: "30%",
          expiry: "2025-11-15"
        },
        {
          id: 3,
          name: "New User Gift",
          reason: "Welcome aboard!",
          discount: "20%",
          expiry: "2025-09-30"
        }
      ])

  useEffect(() => {
    if (user && user.id) {
      axios
        .get(`https://spinelleapi.emedha.in/user/auth/api/profile/${user.id}`)
        .then((res) => {
          setUserData(res.data);
          setFormData(res.data); // Populate form with user data
        })
        .catch((err) => console.log(err));
    }
  }, []);

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (user && user.id) {
      axios
        .put(`https://spinelleapi.emedha.in/user/auth/api/profile/${user.id}`, formData)
        .then((res) => {
          alert("Profile updated successfully");
          setUserData(formData); // Update the user data in the UI
          setActiveTab("overview"); // Optionally switch to the overview tab
        })
        .catch((err) => alert("Update failed"));
    }
  };

  return (
    <>
      <Header />
      <Navbar />
      <div className="profile-container">
        <div className="profile-sidebar">
          <h2>{userData?.first_name} {userData?.last_name}</h2>
          <p className="user-email">{userData?.email}</p>
          <ul>
            <li onClick={() => setActiveTab("edit")} className={activeTab === "edit" ? "active" : ""}>Edit Profile</li>
            <li onClick={() => setActiveTab("orders")} className={activeTab === "orders" ? "active" : ""}>Orders</li>
            <li onClick={() => setActiveTab("payment")} className={activeTab === "payment" ? "active" : ""}>Payment</li>
            {/* <li onClick={() => setActiveTab("appointment")} className={activeTab === "appointment" ? "active" : ""}>Appointment</li> */}
            <li onClick={() => setActiveTab("try-at-home")} className={activeTab === "try-at-home" ? "active" : ""}>Try at Home</li>
            <li onClick={() => setActiveTab("offers")} className={activeTab === "offers" ? "active" : ""}>Offers</li>
            {/* <li onClick={() => setActiveTab("coupons")} className={activeTab === "coupons" ? "active" : ""}>Coupons</li> */}
          </ul>
        </div>

        <div className="profile-main">
          {activeTab === "edit" && (
            <div className="edit-form">
              <h3>Edit Profile</h3>
              <form onSubmit={handleUpdate}>
                <div className="form-group">
                  <label>Name</label>
                  <input name="first_name" value={formData.first_name} onChange={handleInputChange} />
                  <input name="last_name" value={formData.last_name} onChange={handleInputChange} />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input name="email" value={formData.email} onChange={handleInputChange} />
                </div>

                <div className="form-group">
                  <label>Mobile</label>
                  <input name="mobile" value={formData.mobile} onChange={handleInputChange} />
                </div>

                <div className="form-group">
                  <label>Gender</label>
                  <select name="gender" value={formData.gender} onChange={handleInputChange}>
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Pincode</label>
                  <input name="pincode" value={formData.pincode} onChange={handleInputChange} />
                </div>

                <div className="form-group">
                  <label>Date of Birth</label>
                  <input type="date" name="dob" value={formData.dob} onChange={handleInputChange} />
                </div>

                <button type="submit" className="update-btn">Update Profile</button>
              </form>
            </div>
          )}

         {activeTab === "offers" ? (
  <div className="offers-section">
    <h3 className="offers-title">Exclusive Offers for You</h3>
    <div className="coupon-list">
      {coupons.length > 0 ? (
        coupons.map((coupon) => (
          <div className="coupon-card" key={coupon.id}>
            <div className="coupon-header">
              <h4 className="coupon-name">{coupon.name}</h4>
              <span className="coupon-percent">{coupon.discount}OFF</span>
            </div>
            <p className="coupon-reason">{coupon.reason}</p>
            <p className="coupon-expiry">Valid till: {new Date(coupon.expiry).toLocaleDateString()}</p>
          </div>
        ))
      ) : (
        <p className="no-coupons">No active offers at the moment.</p>
      )}
    </div>
  </div>
) : activeTab !== "edit" && (
  <div className="placeholder">
    <h3>{activeTab.replace(/-/g, ' ').toUpperCase()}</h3>
    <p>Feature coming soon...</p>
  </div>
)}

        </div>
      </div>

      <Footer />
      <HelpTrigger />
    </>
  );
};

export default UserProfile;
